import { useMemo } from "react";
import { ZodObject, ZodRawShape, ZodReadonly } from "zod";
import { LaborCostsEntityType } from "@/modules/projects/components/invoiceSpecifications/types/LaborCostsEntityType";

interface Config {
  schema: ZodReadonly<ZodObject<ZodRawShape>>;
}
interface LaborCostsInStoresColumnVisibility {
  config: Config;
  projectDependsOn: LaborCostsEntityType;
}

export const useLaborCostsInStoresColumnVisibility = ({
  config,
  projectDependsOn,
}: LaborCostsInStoresColumnVisibility) => {
  return useMemo(
    () => ({
      ...Object.fromEntries(
        Object.keys(config.schema.unwrap().shape).map((key) => [key, false]),
      ),
      name: true,
      hours: true,
      planned_hours: true,
      rate: true,
      addition: true,
      deduction: true,
      comment: true,
      include_on_invoice: true,
      base_amount: true,
      invoiced_amount: true,
      client_store_number: true,
      ...(projectDependsOn === "department"
        ? { departments: true }
        : { roles: true }),
    }),
    [config, projectDependsOn],
  );
};
